<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
        {{collapsed?'':sysName}}
      </el-col>
      <el-col :span="10">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>
      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner"><img :src="sysUserAvatar" /> {{sysUserName}}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>我的消息</el-dropdown-item>
            <el-dropdown-item>设置</el-dropdown-item>
            <el-dropdown-item @click.native="changePwd">修改密码</el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect" unique-opened router v-show="!collapsed" :style="collapsed?'width:auto':''">
          <template v-for="(item,index) in menuData.filter(d=>!d.hidden)">
            <el-submenu :key="index+''" :index="index+''" v-if="!item.leaf && item.children.length>0">
              <template slot="title">
                <i :class="item.iconCls"></i>{{item.name}}</template>
              <el-menu-item v-for="child in item.children.filter(d=>!d.hidden)" :index="child.path" :key="child.path">{{child.name}}</el-menu-item>
            </el-submenu>
            <!-- <el-menu-item :key="item.children[0].path" v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
              <i :class="item.iconCls"></i>{{item.children[0].name}}1</el-menu-item> -->
          </template>
        </el-menu>
        <!--导航菜单-折叠后-->
        <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
          <li :key="index+''" v-for="(item,index) in menuData.filter(d=>!d.hidden)"  class="el-submenu item">
            <template v-if="!item.leaf && item.children.length>0">
              <div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)">
                <i :class="item.iconCls"></i>
              </div>
              <ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)">
                <li v-for="child in item.children.filter(d=>!d.hidden)" :key="child.path" class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}</li>
              </ul>
            </template>
            <template v-else>
              <!-- <li class="el-submenu">
                <div class="el-submenu__title el-menu-item" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)">
                  <i :class="item.iconCls"></i>
                </div>
              </li> -->
            </template>
          </li>
        </ul>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="breadcrumb-container">
            <strong class="title">{{$route.name}}</strong>
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view :bodyHeight="bodyHeight"></router-view>
            </transition>
          </el-col>
        </div>

        <!--修改密码-->
        <el-dialog title="修改密码" :visible.sync="changePwdFormVisible" :close-on-click-modal="false" size="tiny">
          <el-form :model="changePwdForm" label-width="80px" :rules="changePwdFormRules" ref="changePwdForm">
            <el-form-item label="用户名" prop="nameName">
              <el-input v-model="sysUserName" disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="旧密码" prop="oldPwd">
              <el-input v-model="changePwdForm.oldPwd" type="password"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="newPwd">
              <el-input v-model="changePwdForm.newPwd" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="newPwd2">
              <el-input v-model="changePwdForm.newPwd2" type="password"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click.native="handleChangePwd" :loading="changePwdLoading">确认</el-button>
            <el-button @click.native="changePwdFormVisible = false">取消</el-button>
          </div>
        </el-dialog>
      </section>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      bodyHeight: window.innerHeight,
      sysName: 'ZZTXADMIN',
      collapsed: false,
      sysUserName: '',
      sysUserId: 0,
      sysUserAvatar: require('../assets/logo.png'),
      changePwdFormVisible: false,
      changePwdLoading: false,
      changePwdForm: {
        nameName: '',
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      },
      changePwdFormRules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        newPwd2: [
          {
            validator: (rule, value, callback) => {
              if (value === this.changePwdForm.newPwd) {
                callback()
              } else {
                callback(new Error('两次密码输入不一致'))
              }
            },
            trigger: 'blur'
          }
        ]
      },
      userPermissions: [],
      menuData: []
    }
  },
  methods: {
    onSubmit() {
      console.log('submit!')
    },
    handleopen() {
      // console.log('handleopen');
    },
    handleclose() {
      // console.log('handleclose');
    },
    handleselect: function(a, b) {
    },
    // 修改密码
    changePwd: function() {
      this.changePwdFormVisible = true
      this.changePwdForm = {
        nameName: '',
        oldPwd: '',
        newPwd: '',
        newPwd2: ''
      }
      this.$refs.changePwdForm.resetFields()
    },
    // 修改密码
    handleChangePwd: function() {
      this.$refs.changePwdForm.validate((valid) => {
        if (valid) {
          let para = { oldPwd: this.changePwdForm.oldPwd, newPwd: this.changePwdForm.newPwd }
          this.$ajax({
            url: 'api/Account/ChangeSelfPwd',
            loadingName: 'changePwdLoading',
            data: para
          })
          this.changePwdFormVisible = false
          this.$message({
            message: '修改密码成功',
            type: 'success'
          })
        }
      })
    },
    // 退出登录
    logout: function() {
      var _this = this
      this.$confirm('确认退出吗?', '提示', {
        // type: 'warning'
      }).then(() => {
        this.$ajax('api/Account/Logout')
        sessionStorage.removeItem('user')
        _this.$router.push('/login')
      }).catch(() => {
      })
    },
    // 折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none'
    },
    getUserPermission: function() {
      let para = {
        userId: this.sysUserId
      }
      this.$ajax({
        url: 'api/Account/GetUserPermissionInfo',
        method: 'get',
        data: para,
        success: (d, r) => {
          this.userPermissions = d
          this.$router.options.routes.forEach(element => {
            if (element.children) {
              for (var i = element.children.length - 1; i >= 0; i--) {
                if (!this.ValidatePermission(element.children[i].prcode)) {
                  element.children.splice(i, 1)
                }
              }
            }
          })
          this.menuData = this.$router.options.routes
          console.log(this.menuData)
        }
      })
    },
    ValidatePermission: function(prcode) {
      let result = false
      this.userPermissions.forEach(element => {
        if (element.startsWith(prcode+".")) {
          result = true
          return
        }
      })
      return result
    }
  },
  beforeCreate() {
    /*
  var user = sessionStorage.getItem('user')
  if (user) {
    user = JSON.parse(user)
    this.sysUserName = user.username || ''
    // this.sysUserAvatar = user.avatar || ''
  }
  */
    this.$loading = true
    this.$ajax({
      url: 'api/Account/GetCurrUser',
      type: 'json',
      method: 'get',
      contentType: 'application/json',
      complete: () => { this.$loading = false },
      error: () => {
        this.$router.push('/')
      },
      success: (d, response) => {
        let { data, status } = response
        if (status !== 0) {
          this.$router.push('/')
        } else {
          this.sysUserName = data.userName || ''
          this.sysUserId = data.userId || 0
          this.getUserPermission()
        }
      }
    })
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.bodyHeight = window.innerHeight
      })()
    }
  }
}
</script>

<style scoped lang="less">
@import '../styles/vars.less';

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;
    background: @color-primary;
    color: #fff;
    .userinfo {
      text-align: right;
      padding-right: 35px;
      float: right;
      .userinfo-inner {
        cursor: pointer;
        color: #fff;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }
    .logo {
      //width:230px;
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      border-color: rgba(238, 241, 146, 0.3);
      border-right-width: 1px;
      border-right-style: solid;
      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      width: 230px;
    }
    .logo-collapse-width {
      width: 60px
    }
    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }
  .main {
    display: flex; /*background: #324057;*/
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;
    aside {
      flex: 0 0 230px;
      width: 230px; /* position: absolute;
       top: 0px;
       bottom: 0px;*/
      .el-menu {
        height: 100%;
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
    }
    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
    }
  .content-container {
    /*background: #f1f2f7;*/
    flex: 1; /*position: absolute;
      right: 0px;
       top: 0px;
       bottom: 0px;
       left: 230px;*/
    overflow-y: hidden;
    padding: 10px;
    .breadcrumb-container {
        //margin-bottom: 15px;
        padding: 5px 10px 5px 10px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }
      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  }
}
</style>